export const LIST_PERFIS = "PERFIL/LIST_PERFIS";
export const SET_PERFIS = "PERFIL/SET_PERFIS";
export const SET_PERFIL = "PERFIL/SET_PERFIL";

export const LIST_CATEGORIAS = "PERFIL/LIST_CATEGORIAS";

export const SET_PAGINATION = "PERFIL/SET_PAGINATION";
export const SET_ERROR = "PERFIL/SET_ERROR";
export const SET_LOADING = "PERFIL/SET_LOADING";